import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

import React from "react";
import { DataFormControl } from "../DataFormControl";
import { IDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/IDataDefinition";
import { StringDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/StringDataDefinition";

import { PropertyEditorTextList } from "../../../CommonUI/PropertyEditing/PropertyEditorTextList";
import { PropertyEditorSelect } from "../../../CommonUI/PropertyEditing/PropertyEditorSelect";
import { DataUtilities } from "../../../rule-engine-core/Common/DataUtilities";
import { UISpacedBoxContent } from "../../../CommonUI/BuildlingBlocks/UISpacedBoxContent";
import { UIRadioGroup } from "../../../CommonUI/BuildlingBlocks/UIRadioGroup";

export enum IRadioStyleType {
    CHECKBOX = "checkbox",
    RADIO = "radio",
}

class XRadioGroupEditUI extends React.Component<{ editMe: RadioGroupFormControl }> {
    render() {
        return (
            <UISpacedBoxContent>
                {this.props.editMe.renderBaseDataControlEditor()}

                <PropertyEditorTextList
                    editObject={this.props.editMe}
                    propertyName={"list"}
                    label="List"
                />
                <PropertyEditorSelect
                    editObject={this.props.editMe}
                    propertyName={"styleType"}
                    label="Style Type"
                    options={[IRadioStyleType.RADIO, IRadioStyleType.CHECKBOX]}
                />
            </UISpacedBoxContent>
        );
    }
}

export class RadioGroupFormControl extends DataFormControl {
    readonly __type: string = "Radio Group";
    list: string[] = [];
    styleType: IRadioStyleType = IRadioStyleType.RADIO;

    render() {
        let items = this.list;

        if (!items || items.length === 0) {
            items = ["needs configuration", "please setup"];
        }

        return (
            <FormControl component="fieldset">
                <FormLabel component="legend">{this.label}</FormLabel>
                <UIRadioGroup
                    value={this.valueName ? this.getFormDataValue(this.valueName) : String}
                    onChange={this.handleChange}
                    items={items.map((i) => {
                        return { value: i };
                    })}
                ></UIRadioGroup>
            </FormControl>
        );
    }

    renderEditUI(): JSX.Element | null {
        return <XRadioGroupEditUI editMe={this} />;
    }

    getAddedData(): IDataDefinition | IDataDefinition[] | undefined {
        if (!this.valueName) return;

        let def = new StringDataDefinition();
        def.name = this.valueName;
        return def;
    }

    getStorageData(): object {
        let retData = super.getStorageData();

        retData = DataUtilities.addStorageData(this, retData, "__type", "list", "styleType");

        return retData;
    }

    setStorageData(data: object): void {
        super.setStorageData(data);

        DataUtilities.setStorageData(this, data, "__type", "list", "styleType");
    }

    private handleChange = (value: string | undefined) => {
        if (this.valueName) {
            this.setFormDataValue(this.valueName, value);
        }
    };
}
